export default function createFetchUserPlugin(api) {
  return async (store) => {
    let user;

    try {
      const meResponse = await api.users.me()
      user = meResponse.data.data

    } catch (err) {
      user = null
    }

    store.commit('users/setUser', user)
  };
}
